/**
* IngameOutLink class
* @category lineage2common
*/
class IngameOutLink {
    constructor(_store = {}){
        this.store = _store;

        if (this.store.getData('config').device === 'ingame') {
            this.blackList = [
                'lineage2.plaync.com/promo/lineage2',
                'lineage2.plaync.com/events/',
                'lineage2.plaync.com/classic/events/',
                'lineage2.plaync.com/promo/lineage2classic',
                'lineage2.plaync.com/promotion/',
                'lineage2.plaync.com/update/',
                'lineage2.plaync.com/classic/update/',
                'lineage2.plaync.com/classic/special/',
                'lineage2.plaync.com/classic/promotion/'
            ];
    
            this.addEvents();
        }

    }

    addEvents(){
        $('#container').on('click', 'a', (e)=>{
            let link = e.currentTarget.href;
            if (this.isOutLink(link)) {
                if (confirm('웹 페이지로 이동합니다. 계속 하시겠습니까?')) {
                    window.open(link, '_blank');
                }
                return false;
            }
        });
    }

    isOutLink(link){
        if(link.indexOf('javascript:')>=0){
            return false;
        }

        if(link === '#'){
            return false;
        }
        
        if( link.indexOf('store.plaync.com')>0 ){
            return false;
        }
        
        if( link.substring(0,1)==='/' || link.indexOf('lineage2.plaync.com')>0  ){
            let cutLink = 'lineage2.plaync.com' + link.split('lineage2.plaync.com').pop();
            for (let i = 0; i < this.blackList.length; i++) {
                if( cutLink.indexOf(this.blackList[i]) >= 0 ){
                    return true;
                }
            }
        } else {
            return true;
        }

        return false;
    }




} // end of class
export default IngameOutLink;